import { LANGUAGE_PROFICIENCY_LEVEL_MAPPING } from './constants';

export const parseProficientLanguagesArrayToObject = (languagesArray = []) => {
    const languagesObject = {};

    languagesArray.forEach(({ name, level }) => {
        languagesObject[name] = LANGUAGE_PROFICIENCY_LEVEL_MAPPING[level];
    });

    return languagesObject;
};
